import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import BlockPlaceholder from './BlockPlaceholder';
import InlinePlaceholder from './InlinePlaceholder';

export default class Placeholder extends Plugin {
    static get requires() {
        return [BlockPlaceholder, InlinePlaceholder];
    }
}